<template>
  <tr>
    <td>
      <div class="grid">
        <div class="grid__col--2"><div :class="`chartColor__box chartColor__box--${title}`">&nbsp;</div></div>
        <div class="grid__col--10">{{ title }}</div>
      </div>
    </td>
    <td v-for="location in validLocations" v-bind:key="location.location_id">{{ location.totals[locationProperty] }}</td>
    <td v-for="location in extraLocations">&nbsp;</td>
  </tr>
</template>

<script>
  export default {
    name: 'TableRow',
    props: {
      title: {
        type: String,
      },
      locationProperty: {
        type: String,
      },
      validLocations: {
        type: Array,
      },
      extraLocations: {
        type: Array,
      },
    },
  };
</script>
